import { format } from "date-fns";
import { type TodoGuidance as TodoGuidanceResponse } from "../api";
import { Utility } from "./utility";

export interface TodoGuidance extends TodoGuidanceResponse {}

export class TodoGuidance extends Utility<TodoGuidance> {
  constructor(init?: Partial<TodoGuidanceResponse>) {
    super();
    Object.assign(this, init);
  }

  get local_updated_at(): Date | undefined {
    if (this.updated_at === undefined) return undefined;
    return this.get_local_time(this.updated_at);
  }

  get local_updated_at_string(): string {
    if (!this.local_updated_at) return "";
    return format(this.local_updated_at, "yyyy/M/d h:mmaa");
  }
}
